import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.constructor";
// Theme registry + helpers. Pure JS, no Vue/store dependencies.
// Removal: see .ai-memory/ui-redesign-plan.md ("Removal path").
export var THEMES = ['modern-light', 'modern-dark', 'neon', 'glass'];
export var DEFAULT_THEME = 'modern-light';
export var DARK_THEMES = ['modern-dark', 'neon'];
var STORAGE_KEY = 'gm-theme'; // localStorage: saved preference

var SESSION_KEY = 'gm-theme-session'; // sessionStorage: ?theme= override for this session

var QUERY_PARAM = 'theme';
export var isTheme = function isTheme(name) {
  return THEMES.indexOf(name) !== -1;
};

var safeGet = function safeGet(storage, key) {
  try {
    return window[storage].getItem(key);
  } catch (e) {
    return null;
  }
};

var safeSet = function safeSet(storage, key, value) {
  try {
    if (value === null) {
      window[storage].removeItem(key);
    } else {
      window[storage].setItem(key, value);
    }
  } catch (e) {// storage unavailable (private mode, blocked) - theme still applies for this page load
  }
};

export var readQueryTheme = function readQueryTheme() {
  var match = new RegExp('[?&]' + QUERY_PARAM + '=([^&#]*)').exec(window.location.search);
  var name = match ? decodeURIComponent(match[1]) : null;
  return isTheme(name) ? name : null;
}; // Priority: ?theme= (stored as session override) → session override → saved → default

export var resolveInitialTheme = function resolveInitialTheme() {
  var fromQuery = readQueryTheme();

  if (fromQuery) {
    safeSet('sessionStorage', SESSION_KEY, fromQuery);
    return fromQuery;
  }

  var fromSession = safeGet('sessionStorage', SESSION_KEY);
  if (isTheme(fromSession)) return fromSession;
  var saved = safeGet('localStorage', STORAGE_KEY);
  if (isTheme(saved)) return saved;
  return DEFAULT_THEME;
}; // Dark = Quasar v1 Dark plugin (optional), so Quasar components render their dark variants

export var applyTheme = function applyTheme(name, Dark) {
  var theme = isTheme(name) ? name : DEFAULT_THEME;
  document.documentElement.setAttribute('data-theme', theme);
  if (Dark) Dark.set(DARK_THEMES.indexOf(theme) !== -1);
  return theme;
}; // Explicit user choice: persist it and drop any ?theme= session override

export var saveTheme = function saveTheme(name) {
  if (!isTheme(name)) return;
  safeSet('localStorage', STORAGE_KEY, name);
  safeSet('sessionStorage', SESSION_KEY, null);
};